import { themeColors } from "@dana/MobiusOverrides/styles/colors";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { dateRangeStyles } from "@insite/content-library/Widgets/OrderHistory/OrderHistorySearchFieldDateRange";
import { css } from "styled-components";

dateRangeStyles.toDate = mergeToNew(dateRangeStyles.toDate, {
    labelProps: {
        color: themeColors.primary.richBlack,
    },
});

dateRangeStyles.datePickersWrapper =  mergeToNew(dateRangeStyles.datePickersWrapper, {
    css: css`
        gap: 20px;
        &,
        > div {
            width: 100%;
        }
        [class*="FormFieldLabel"] + [class*="FormInputWrapper"] {
            margin-top: 4px;
        }
        .react-datetime-picker {
            height: 42px;
        }
        > div {
            &:last-child {
                .react-calendar {
                    left: auto;
                    right: 0;
                }
            } 
        }
        [class*="FormFieldStyle"] {
            padding: 0;
            @media screen and (min-width: 992px) and (max-width: 1199px) {
                .react-datetime-picker__calendar-button {
                    [class*="IconWrapper"] {
                        padding: 8px 0;
                        width: 16px;
                    }
                }
				.react-datetime-picker:not(:disabled){
					.react-datetime-picker__inputGroup {
						padding-left: 4px;
					}
				}
            }
        }
    `
});